import * as React from 'react';

const ArrowUpChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        className="arrow-up-chunky_svg__eds-icon--arrow-up-chunky_svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            className="arrow-up-chunky_svg__eds-icon--arrow-up-chunky_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.5 13.5L11 8v12h2V8l5.5 5.5L20 12l-8-8-8 8z"
        />
    </svg>
);

ArrowUpChunkySvg.displayName = 'ArrowUpChunkySvg';
export default ArrowUpChunkySvg;
